import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, CameraIcon } from 'lucide-react';
import { Avatar } from '../components/ui/Avatar';
import { Input } from '../components/ui/Input';
import { MOCK_USERS } from '../data/mockData';
export function EditProfile() {
  const navigate = useNavigate();
  const user = MOCK_USERS[0];
  const [name, setName] = useState(user.name);
  const [username, setUsername] = useState(user.username);
  const [bio, setBio] = useState(user.bio);
  const handleSave = () => {
    navigate('/profile');
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-373">
      {/* Header */}
      <div className="px-4 py-4 flex justify-between items-center border-b border-border" data-id="element-374">
        <button onClick={() => navigate(-1)} className="text-white" data-id="element-375">
          <ArrowLeftIcon size={24} data-id="element-376" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-377">
          Edit Profile
        </h1>
        <button onClick={handleSave} className="text-primary font-bold text-sm" data-id="element-378">
          Save
        </button>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar p-6" data-id="element-379">
        {/* Avatar Edit */}
        <div className="flex flex-col items-center mb-8" data-id="element-380">
          <div className="relative" data-id="element-381">
            <Avatar src={user.avatar} size="xl" className="opacity-50" data-id="element-382" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-383">
              <CameraIcon size={32} className="text-white" data-id="element-384" />
            </div>
          </div>
          <button className="text-primary text-sm font-bold mt-4" data-id="element-385">
            Change Photo
          </button>
        </div>

        {/* Form */}
        <div className="space-y-6" data-id="element-386">
          <Input label="Name" value={name} onChange={e => setName(e.target.value)} data-id="element-387" />

          <Input label="Username" value={username} onChange={e => setUsername(e.target.value)} data-id="element-388" />

          <div className="flex flex-col gap-1.5" data-id="element-389">
            <label className="text-sm font-medium text-softGray ml-1" data-id="element-390">
              Bio
            </label>
            <textarea value={bio} onChange={e => setBio(e.target.value)} className="w-full bg-surface border border-border rounded-xl px-4 py-3.5 text-white placeholder:text-softGray focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors min-h-[100px] resize-none" data-id="element-391" />
          </div>

          <div className="pt-4 border-t border-border" data-id="element-392">
            <h3 className="text-white font-bold mb-4" data-id="element-393">Social Links</h3>
            <div className="space-y-4" data-id="element-394">
              <Input placeholder="Instagram username" data-id="element-395" />
              <Input placeholder="YouTube channel URL" data-id="element-396" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}